<template>
  <v-menu :close-on-content-click="false" max-width="320" offset-x>
    <template v-slot:activator="{ on }">
      <FilterBottom v-on="on" />
    </template>

    <v-card>
      <v-container>
        <BaseFilter
          prepend-inner-icon="mdi-file-table-box-multiple-outline"
          clearable
          single-line
          label="Segmento"
          item-text="descricao"
          item-value="id_band"
          service="sistemaService.tipoBandeiras"
          :filters="{ id_band: '2,4' }"
          v-model="filters.id_band"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-domain"
          clearable
          single-line
          label="Empresa"
          item-text="apelido"
          item-value="id_empresa"
          service="sistemaService.empresa"
          :filters="{ id_band: filters.id_band, calcula_comissao: 'S' }"
          v-model="filters.id_empresa"
          :isCompany="true"
          @change="handleFilter()"
        />

        <BaseFilter
          prepend-inner-icon="mdi-account-group"
          clearable
          single-line
          label="Equipes"
          item-text="nome_equipe"
          item-value="id_equipe"
          service="comissaoService.tipoEquipe"
          :filters="{
            id_band: filters.id_band,
            id_empresa: filters.id_empresa,
            ativo: 'S'
          }"
          v-model="filters.id_equipe"
          @change="handleFilter()"
        />
        <BaseFilter
          prepend-inner-icon="mdi-toolbox"
          clearable
          single-line
          chips
          label="Departamento"
          item-text="departamento"
          item-value="id_depto"
          service="comissaoService.departamentos"
          v-model="filters.id_depto"
          @change="handleFilter()"
        />

        <DatePickerMonth @date="assignDateFilter($event)" />
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
import BaseFilter from "@/components/shared/BaseSelectService";
import FilterBottom from "@/components/shared/bottons/FilterBottom";
import DatePickerMonth from "@/components/shared/DatePickerMonth";

export default {
  components: {
    BaseFilter,
    FilterBottom,
    DatePickerMonth
  },

  data() {
    return {
      filters: {}
    };
  },

  methods: {
    handleFilter() {
      this.$emit("selectedFilters", this.filters);
    },
    assignDateFilter(date) {
      this.filters["ano_ref"] = date?.ano_ref;
      this.filters["mes_ref"] = date?.mes_ref;
      this.handleFilter();
    }
  }
};
</script>

<style></style>
